import React, { useEffect, useState } from 'react';
import ContentCard from '../../../Common/Card';
import Icons from '../../../../../components/Common/Icons/Icons';
import MenuIcon from '../../../Layout/Menu/MenuIcon';
import DataTable from '../../../../../components/Common/UI/DataTable';
import { INoticesData, noticesCol, noticesData } from '../Data';
import { cn } from '../../../../../utils/styles';
import { Button } from '../../../../../components/Common/UI/Button';
import { usePdfDialogProvider } from '../../../../../context/pdfViewerDialog';
import { IAccountData } from '../../../Layout/Account/Data';

interface NoticesProps {
  search?: string;
}

type IFilters = 'all' | 'unviewed';

const filters: IFilters[] = ['all', 'unviewed'];
// const ALLOWED_ACCOUNTS_FOR_USER = ['****4560', '****4564'];
const viewerUpdatesRaw = localStorage.getItem('viewerUpdates');

const ALLOWED_ACCOUNTS_FOR_USER = viewerUpdatesRaw
  ? (JSON.parse(viewerUpdatesRaw).find((u: IAccountData) => u.id === '1')?.selectedAccounts ?? [])
  : ['****4560', '****4564'];

function Notices({ search }: NoticesProps) {
  const [state, setState] = useState<INoticesData[]>(noticesData);
  const [active, setActive] = useState<IFilters>('all');
  const [isAuthorizedUser, setIsAuthorizedUser] = useState(false);
  const { handleOpen } = usePdfDialogProvider();

  useEffect(() => {
    const tempViewers = JSON.parse(localStorage.getItem('tempViewers') || '[]');

    setIsAuthorizedUser(tempViewers.length > 0);
  }, []);

  const handleClick = (payload: IFilters) => {
    setActive(payload);
  };

  useEffect(() => {
    let data = [...noticesData];

    if (isAuthorizedUser) {
      data = data.filter(el => ALLOWED_ACCOUNTS_FOR_USER.includes(el.account));
    }

    if (active === 'unviewed') {
      data = data.filter(el => !el.reviewed);
    }

    if (search?.trim()) {
      const q = search.toLowerCase();

      data = data.filter(
        el =>
          el.account.toLowerCase().includes(q) ||
          el.noticeType.toLowerCase().includes(q) ||
          el.searchKey?.toLowerCase().includes(q) ||
          el.date.toLowerCase().includes(q)
      );
    }

    setState(data);
  }, [active, search, isAuthorizedUser]);

  return (
    <ContentCard
      title="Recent Notices"
      icon={<MenuIcon icon={<Icons.Notice />} className="bg-primary border-primary" variant="white" size="large" />}
      actions={filters.map(el => (
        <Button
          key={el}
          className={cn(
            'px-[10px] rounded-[5px] py-[5px] hover:bg-primary hover:text-white uppercase ' +
              'bg-secondary-10 text-secondary-50 text-sm !h-[28px]',
            {
              'bg-primary border-primary text-white': el === active,
            }
          )}
          onClick={() => handleClick(el)}
        >
          {el}
        </Button>
      ))}
    >
      <DataTable
        responsive
        variant="guidance"
        columns={noticesCol}
        data={state}
        initialState={{ pagination: { pageSize: 10 } }}
        onRow={({ original }) =>
          handleOpen({
            open: true,
            iframeProps: { src: original.filePath },
          })
        }
      />
    </ContentCard>
  );
}

export default Notices;
